import { Box } from '@chakra-ui/react';

const ErrorRouteComponent = () => {
  const test = null;
  test.forEach((el) => console.log(el));
  return <Box>Error</Box>;
};

export default ErrorRouteComponent;
